export enum ClientAccessTypeEnum {
    Unknown = 0,
    SCADALynx_Website = 1,
    Legacy_Mobile = 2,
    HTML5_Mobile = 3,
    iOS_Data_Access = 4,
    Mobile_App = 5,
    Customer_API = 6,
    eLynx_Automated = 7,
    eLynxDesktop = 8, // renamed from eLynxApp2022
    publicApi = 9,
    eLynxMobile = 10
}